export enum MapEvent {
  MAP_CLICK = 'mapClick',
  MARKER_CLICK = 'markerClick',
  RELOCATION_ZONE_MARKER_CLICK = 'relocationZoneMarkerClick',
  FOCUS_MARKER = 'focusMarker',
  MAP_MOVE = 'mapMove'
}

export enum WindowEvent {
  RESIZE = 'resize',
}

export enum DocumentEvent {
  DOCUMENT_SHOW = 'document.show',
  DOCUMENT_HIDE = 'document.hide',
}

export enum DialogEvent {
  SHOW_VERTICAL = 'dialog.show.vertical',
  SHOW_HORIZONTAL = 'dialog.show.horizontal',
  HIDE = 'dialog.hide',
  CLICK = 'dialog.click',
  RELOCATION_ZONE_CLICK = 'dialog.relocationZone.click',
  UPDATE_DEVICE = 'dialog.updateDevice',
}

export enum RouteEvent {
  NAVIGATION_CLICK = 'navigationClick',
}

export enum GeolocationEvent {
  UPDATE_LOCATION = 'geolocation.updateLocation'
}

export enum MainPageEvent {
  REFRESH_DEVICES = 'mainPage.refreshDevices'
}
